<template>
  <div class="d-flex flex-row align-end" :class="rowOrder">
    <optical-cross-image
      v-if="showOpticalCross"
      :dimensions="60"
      type="keratometry"
      :obj="kObject"
      :showHeatmap="showHeatmap"
      class="d-none d-md-inline-flex"
    />
    <div class="flex-grow-1">
      <v-text-field
        class="pt-0 my-0 theInput"
        rounded
        dense
        outlined
        filled
        background-color="#FFF"
        :label="eyePlaceholder"
        :value="inputValue"
        :autofocus="eye == 'od'"
        hide-details="auto"
        @blur="handleChange($event.target.value)"
        @focus="$event.target.select()"
        v-on:keyup.enter="$event.target.blur()"
        :rules="[validK]"
      >
        <!-- v-model.lazy="keratoInputString" -->
      </v-text-field>
      <div class="d-flex flex-row align-center">
        <div class="mt-1 width100p">
          <div v-for="(message, i) in messages" :key="i" class="messageClass">
            {{ message }}
          </div>
        </div>
        <v-fade-transition>
          <k-information-popup
            v-if="kObject && showMoreInfo"
            :kObject="kObject"
            class="mx-1"
          ></k-information-popup>
        </v-fade-transition>
      </div>
    </div>
  </div>
</template>

<script>
import RxMethods from "@/assets/js/cls/RxMethods";
import OpticalCrossImage from "@/components/clStuff/OpticalCrossImage";

/* NOTE: IF CHANGING THINGS HERE CONSIDER CHANGING IN RXINPUT.VUE AS WELL */

export default {
  name: "KeratoInput",
  components: {
    OpticalCrossImage,
    KInformationPopup: () =>
      import("@/components/clStuff/KInformationPopup.vue"),
  },
  mixins: [RxMethods],
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    eye: {
      type: String,
      default: "none",
    },
    kString: {
      type: String,
      default: "",
    },
    showOpticalCross: null,
    showKcyl: null, // shows something like "2.00D WTR" in the messages
    showConverted: null, // if D show mm and vice versa (in the messages)
    crossPosition: null,
    showHeatmap: null,
    showMoreInfo: null,
    // put cross on left or right of input? showOpticalCross must be true
    // if not set, looks at eye: "od" puts cross on left, "os" on right
  },
  data: function () {
    return {
      keratoInputString: "",
      kObject: null,
      validK: true,
    };
  },
  methods: {
    // formatKeratoInput: function() {
    //   let keratometryObject = this.fullKStringBreaker(this.keratoInputString);
    //   if (keratometryObject) {
    //     this.keratoInputString = this.prettyFullKstring(keratometryObject);
    //     this.$emit("kChange", keratometryObject);
    //   }
    // },

    handleChange: function (val) {
      let kObject = this.fullKStringBreaker(val);
      // console.log(kObject);
      let noK = val == "" || !val;
      let isValid = true;
      if (noK) kObject = null;
      if (!noK) isValid = this.isValidFullK(kObject);
      if (isValid) {
        this.kObject = kObject;
        this.validK = isValid;
        this.$emit("kChange", kObject);
      } else {
        this.validK = false;
      }
    },
  },
  computed: {
    eyePlaceholder: function () {
      if (this.placeholder != "") return this.placeholder;
      if (this.placeholder === "none") return "";
      return this.eye === "os"
        ? "Left eye keratometry"
        : "Right eye keratometry";
    },
    inputValue: function () {
      return this.kString;
    },
    rowOrder: function () {
      if (this.crossPosition && this.crossPosition == "right")
        return "flex-row-reverse";
      if (this.eye == "os") return "flex-row-reverse";
      return "";
    },
    messages: function () {
      let msg = [];
      if (this.validK && this.kObject) {
        if (this.showConverted) {
          let cString = this.prettyFullKstringConverted(this.kObject);
          msg.push(cString);
        }
        if (this.showKcyl) {
          let cylString = `Cyl: ${this.cornealCyl(
            this.kObject
          )}D ${this.cylType(this.kObject)}`;
          msg.push(cylString);
        }
      } else {
        msg.push("Please enter valid Keratometry");
      }
      return msg;
    },
  },
  watch: {
    kString: function () {
      this.handleChange(this.kString);
    },
  },
  mounted() {
    if (this.kString) this.handleChange(this.kString);
  },
};
</script>

<style scoped>
.messageClass {
  line-height: 15px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 11px;
}
</style>
